export default __webpack_public_path__ + "static/media/590.d109cc98.jpg";